
import { TECHNICAL_INDICATORS, EVENT_GENRE, EVENT_SECTOR, FOREX_LIST, EXCHANGE_LIST, API_CONTROL_PANEL_INPUT_TYPE } from "@/assets/apiDocs/api_constants.js";

export const beta_api_category = [
  "Get Started",
  "Stock API",
  // "Forex API",
  "Crypto API",
  "Reference API"
];
export const beta_api_menu_by_category = {
  "Get Started": [
    "Introduction",
    "Security",
    "Credit System",
    "Community Support and SDK",
    "URL Format",
    "Google Sheet and Excel Plug-in",
    "Error Code"
  ],
  "Stock API": [
    // "Realtime Stock Price",
    "Historical Stock Price",
    "Stock Technical Indicators",
    "Company Financials",
    "Company Profile",
    "Company Financial Summary",
    "Ownership Structure",
    "Insider Transaction",
    "SEC Filing Link",
    "Latest Stock News",
    "Stock News by Event Classification",
    "Stock News by Sentiment",
    "Stock News by Name Entities",
  ],
  "Crypto API": ["Historical Crypto Price"],
  // "Forex API": ["Realtime Forex Price"],
  "Reference API": [
    "Asset Coverage",
    "CIK Number"
  ]
};

const data_type_param = ["datatype", "Optional", "By default, datatype=json. if datatype=csv specified, returns response result as a CSV (comma separated) file"];
const access_key_param = ["AccessKey", "Required", "Claim your API key here"];

const Beta_API = {
  // "Realtime Stock Price": {
  //   api_category: beta_api_category[1],
  //   costs: ["1 credit per data point"],
  //   description: [
  //     "This API offers real time stock quotes for securities trading around the globe."
  //   ],
  //   feature: [
  //     "This API covers real time price quote over 63000 companies, ETFs and Mutual Funds,traded in the major exchanges around the world. Find all the companies that we support, please checkout our Asset Coverage API",
  //     "This API is updated every minute.",
  //     "All intraday quotes are provided in local time with GMT offset.",
  //     "All intraday quotes are adjusted by dividends and splits."
  //   ],
  //   base_url: "https://api.unibit.ai/api/realtimestock/",
  //   template_urls: [
  //     "https://api.unibit.ai/api/realtimestock/{{ticker}}?size={{A positive Integer}}&datatype={{json}}&AccessKey={{your access key}}"
  //   ],
  //   example_urls: ["https://api.unibit.ai/api/realtimestock/AAPL?AccessKey=Demo"],
  //   csv_urls: ["https://api.unibit.ai/api/realtimestock/AAPL?datatype=csv&AccessKey=Demo"],
  //   input_params: {
  //     path_params: {
  //       description: "",
  //       table_header: ["Parameters", "Requirement", "Details"],
  //       table_data: [["ticker", "Required", "Choose the symbol of a company"]]
  //     },
  //     query_params: {
  //       description: "",
  //       table_header: ["Parameters", "Requirement", "Details"],
  //       table_data: [
  //         [
  //           "size",
  //           "Optional",
  //           "Default: return all real time stock prices of that ticker. Otherwise, return the number of objects(JSON) or rows(CSV) specified"
  //         ],
  //         data_type_param,
  //         access_key_param
  //       ]
  //     }
  //   },
  //   response_params: {
  //     meta_data: {
  //       ticker: "AAPL",
  //       date: "02/02/2020"
  //     },
  //     description: "",
  //     table_header: ["name", "type", "Description"],
  //     table_data: [
  //       ["Ticker", "String", "Choose the symbol of a company"],
  //       [
  //         "date",
  //         "String",
  //         "Returns the date of the trading session. Date format is: yyyymmdd"
  //       ],
  //       [
  //         "minute",
  //         "String",
  //         "Returns the specific time of the trading session. Minute format is: hh:mm"
  //       ],
  //       ["volume", "Number", "Returns the trading volume"],
  //       [
  //         "price",
  //         "Number",
  //         "Returns the latest price quote for the company selected. Price example: 123.45"
  //       ],
  //       ["timezone", "String", "Returns the timezone symbol"],
  //       ["timezone_name", "String", "Returns the timezone name"],
  //       ["gmt_offset", "Number", "Returns the GMT offset value"]
  //     ]
  //   }
  // },

  "Historical Stock Price": {
    api_category: beta_api_category[1],
    costs: ["10 credit per data point"],
    description: [
      "This API offers End of Date stock quotes for active stock listings that go back 20 years."
    ],
    feature: [
      "This API covers historical price quote for over 63000 companies, ETFs and Mutual Funds,traded in the major exchanges around the world. Find all the companies that we support, Please checkout our Asset Coverage API",
      "This API is updated every day at or before 5:30pm EST.",
      "20 years of historical data dates back to 1998.",
      "Corporate actions for splits, dividends, spinoffs, bonus shares and distributions are adjusted "
    ],
    base_url: "https://api.unibit.ai/api/historicalstockprice/",
    template_urls: [
      "https://api.unibit.ai/api/historicalstockprice/{{ticker}}?range={{see possible options}}&interval={{A positive Integer}}&datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/historicalstockprice/AAPL?range=1m&interval=3&AccessKey=Demo",
      "https://api.unibit.ai/api/historicalstockprice/AAPL?range=3y&interval=100&AccessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/historicalstockprice/AAPL?range=3y&interval=100&datatype=csv&AccessKey=Demo"
    ],
    possible_options: {
      description: "",
      table_header: ["Time Range", "Frequency", "Description"],
      table_data: [
        [
          "1m",
          "One month",
          "Historically adjusted stock price quote for the past 1 month"
        ],
        [
          "3m",
          "Three months",
          "Historically adjusted stock price quote for the past 3 months"
        ],
        [
          "1y",
          "One years",
          "Historically adjusted stock price quote for the past 1 year"
        ],
        [
          "3y",
          "Three years",
          "Historically adjusted stock price quote for the past 3 years"
        ],
        [
          "5y",
          "Five years",
          "Historically adjusted stock price quote for the past 5 years"
        ],
        [
          "10y",
          "Ten years",
          "Historically adjusted stock price quote for the past 10 years"
        ],
        [
          "20y",
          "Twenty years",
          "Historically adjusted stock price quote for the past 20 years"
        ]
      ]
    },
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          ["range", "Required", "Choose from range options above (i.e. 1m)"],
          [
            "interval",
            "Required",
            "A positive Integer (n). If passed, chart data will return every nth element as defined by Interval"
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020",
        range: "1 month",
        interval: 1
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        [
          "date",
          "String",
          "Returns the date of the trading session. Date format is: yyyy-mm-dd"
        ],
        [
          "open",
          "Number",
          "Returns open price for the stock when market opens"
        ],
        [
          "high",
          "Number",
          "Returns intraday highest price for the stock in a market trading day"
        ],
        [
          "low",
          "Number",
          "Returns intraday lowest price for the stock when in a market trading day"
        ],
        [
          "close",
          "Number",
          "Returns close price for the stock when market closes"
        ],
        [
          "adj_close",
          "Number",
          "Returns close price for the stock adjusted for splits, and dividends"
        ],
        ["volume", "Number", "Returns trading volume for a day"]
      ]
    },
  },

  "Stock Technical Indicators": {
    api_category: beta_api_category[1],
    costs: ["1 credit per data point"],
    description: [
      "Technical indicators are mathematical calculations derived from the price, volume, open, high, low data points of a security. Through studying the pattern of technical indicator trendline, traders can make a prediction of the price movement."
    ],
    feature: [
      "Daily updated for 63000 stocks ",
      "Includes 23 technical indicators; SMA, EMA, RSI, WMA, MMA, DoubleEMA, TripleEMA, ZLEMA, UlcerIndex, ROC, HMA, CMO, StochasticRSI, VWAP, ADX, CCI, StochasticOscillatorK, AROONDOWN, AROONUP, WilliamsR, RWLow, RWIHigh, DPO",
      "Returns technical indicators value for the stock"
    ],
    base_url: "https://api.unibit.ai/api/technicalindicators/",
    template_urls: [
      "https://api.unibit.ai/api/technicalindicators/?ticker={{ticker}}&function={{indicator type}}&interval={{dalily}}&range={{see possible options}}&data_point={{A positive Integer}}&series_type={{Open/Close}}&datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/technicalindicators?function=SMA&ticker=aapl&data_point=100&series_type=close&interval=daily&range=1w&AccessKey=demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/technicalindicators?datatype=csv&function=SMA&ticker=aapl&data_point=100&series_type=close&interval=daily&range=1w&&AccessKey=demo"
    ],

    possible_options: {
      description: "",
      table_header: ["Function", "Requirement", "Description"],
      table_data: [
        [
          "SMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "EMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "RSI",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "WMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "MMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "DoubleEMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "TripleEMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "ZLEMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "UlcerIndex",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "ROC",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "HMA",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "CMO",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        [
          "StochasticRSI",
          "data_point, series_type, interval",
          "requires these 3 input parameters"
        ],
        ["VWAP", "data_point, interval", "requires these 2 input parameters"],
        ["ADX", "data_point, interval", "requires these 2 input parameters"],
        ["CCI", "data_point, interval", "requires these 2 input parameters"],
        [
          "StochasticOscillatorK",
          "data_point, interval",
          "requires these 2 input parameters"
        ],
        [
          "ARRONDOWN",
          "data_point, interval",
          "requires these 2 input parameters"
        ],

        [
          "ARROONUP",
          "data_point, interval",
          "requires these 2 input parameters"
        ],
        [
          "WilliamR",
          "data_point, interval",
          "requires these 2 input parameters"
        ],
        [
          "RWILow",
          "data_point, interval",
          "requires these 2 input parameters"
        ],
        [
          "RWIHigh",
          "data_point, interval",
          "requires these 2 input parameters"
        ],
        ["DPO", "data_point, interval", "requires these 2 input parameters"],
        ["ATR", "data_point, interval", "requires these 2 input parameters"],
        [
          "MACD",
          "series_type, interval",
          "requires these 2 input parameters"
        ],
        [
          "BBANDSM",
          "series_type, interval",
          "requires these 2 input parameters"
        ],
        [
          "KAMA",
          "series_type, interval",
          "requires these 2 input parameters"
        ],
        ["PPO", "series_type, interval", "requires these 2 input parameters"],
        [
          "CoppockCurve",
          "series_type, interval",
          "requires these 2 input parameters"
        ],
        ["OBV", "interval", "requires these 1 input parameters"],
        ["ParabolicSar", "interval", "requires these 1 input parameters"],
        ["Fisher", "interval", "requires these 1 input parameters"],
        [
          "ChandelierExitShort",
          "interval",
          "requires these 1 input parameters"
        ],
        [
          "ChandelierExitLong",
          "interval",
          "requires these 1 input parameters"
        ]
      ]
    },

    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          [
            "function",
            "Required",
            "Choose from SMA, EMA, RSI, WMA, MMA, DoubleEMA, TripleEMA, ZLEMA, UlcerIndex, ROC, HMA, CMO, StochasticRSI"
          ],
          ["interval", "Required", "Choose from daily, weekly, monthly"],
          ["range", "Optional", "Choose from range options above (i.e. 1m)"],
          [
            "data_point",
            "Required",
            "Choose from a number of data points for calculating technical indicators"
          ],
          ["series_type", "Required", "Choose from Open, Close, High, Low"],

          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        "Technical Indicator": "SMA"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["Ticker", "String", "Choose the symbol of a company"],
        [
          "date",
          "String",
          "Returns the date of the trading session. Date format is: yyyymmdd"
        ],
        [
          "minute",
          "String",
          "Returns the specific time of the trading session. Minute format is: hh:mm"
        ],
        [
          "price",
          "Number",
          "Returns the latest price quote for the company selected. Price example: 123.45"
        ]
      ]
    }
  },

  "Company Financials": {
    api_category: beta_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "The Core Financials Dataset includes over 50 financial indicators, which are descriptive company details and ratios. The companies included are all SEC reporting companies with publicly traded securities. Data including balance sheets, income statements and cash flow are available for the last 4 years."
    ],

    feature: [
      "This API covers over 3500 companies traded in the major U.S exchanges including NASDAQ, AMEX, NYSE, and ARCA.",
      "This API is updated based on the company’s earning announcement and quarterly results.",
      "Historical financial statement covers 4 years of data.",
      "To get a full list of companies that we cover, you may use the API here."
    ],
    base_url: "https://api.unibit.ai/api/financials/",
    template_urls: [
      "https://api.unibit.ai/api/financials/{{ticker}}?type={{document type}}&interval={{annual or quarterly}}&datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/financials/AAPL?type=income_statement&interval=annual&AccessKey=Demo",
      "https://api.unibit.ai/api/financials/AAPL?type=balance_sheet&interval=quarterly&AccessKey=Demo",
      "https://api.unibit.ai/api/financials/AAPL?type=cash_flow&interval=quarterly&AccessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/financials/AAPL?type=cash_flow&interval=quarterly&datatype=csv&AccessKey=Demo"
    ],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["Ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          [
            "type",
            "Required",
            'Choose from "income_statement", "balance_sheet", or "cash_flow"'
          ],
          ["interval", "Required", 'Choose from "annual" or "quarterly"'],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "For example, income statement response looks like this:",
      table_header: ["Name", "Type", "Description"],
      table_data: [
        [
          "Total Revenue",
          "Number",
          "Return total revenue produced by a company"
        ],
        [
          "Operating Revenue",
          "Number",
          "Return operating revenue produced by a company"
        ],
        [
          "Gross Profit",
          "Number",
          "Return gross profit produced by a company"
        ],
        ["Total Cost", "Number", "Return total cost incurred by a company"],
        [
          "Operating Income",
          "Number",
          "Return operating income produced by a company"
        ],
        [
          "Operating Expense",
          "Number",
          "Return operating expense incurred by a company"
        ],
        ["R&D", "Number", "Return R&D cost incurred by a company"],
        ["Net Income", "Number", "Return net income produced by a company"]
      ]
    },
    possible_options: {
      description: "",
      table_header: ["Financials Type", "Frequency", "Description"],
      table_data: [
        [
          "income_statement",
          '"annual" or "quarterly"',
          "Company’s income statement"
        ],
        [
          "balance_sheet",
          '"annual" or "quarterly"',
          "Company’s balance sheet"
        ],
        [
          "cash_flow",
          '"annual" or "quarterly"',
          "Company’s cash flow statement"
        ]
      ]
    }
  },

  "Company Profile": {
    api_category: beta_api_category[1],
    costs: ["10 credit per data point"],
    description: [
      "Company profile API provides basic information about each company including its name, industry, website, description, leadership sector and asset type."
    ],
    base_url: "https://api.unibit.ai/api/companyprofile/",
    template_urls: [
      "https://api.unibit.ai/api/companyprofile/{{ticker}}?datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/companyprofile/AAPL?AccessKey=Demo"],
    csv_urls: ["https://api.unibit.ai/api/companyprofile/AAPL?datatype=csv&AccessKey=Demo"],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        datapoints: 1,
        ticker: "AMZN",
        "credit cost": 100,
        "Time Zone": "America/New_York",
        "last refreshed": "06/10/2019 at 03:25PM ET"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Returns selected company’s ticker"],
        ["company name", "String", "Returns selected company’s name"],
        [
          "address",
          "String",
          "Return address for the selected company’s security"
        ],
        ["phone", "String", "Returns selected company’s phone"],
        ["website", "String", "Returns selected company’s website"],

        ["sector", "String", "Returns selected company security’s sector "],
        ["industry", "String", "Returns selected company’s industry"],
        [
          "employee number",
          "String",
          "Returns selected company’s employee number"
        ],
        [
          "executive1 name",
          "String",
          "Returns selected company’s executive1 name"
        ],
        [
          "executive1 title",
          "String",
          "Returns selected company’s executive1 title"
        ],
        [
          "executive1 pay",
          "String",
          "Returns selected company’s executive1 pay"
        ],
        [
          "executive1 exercised",
          "String",
          "Returns selected company’s executive1 exercised"
        ],
        [
          "executive1 yearborn",
          "String",
          "Returns selected company’s executive1 yearborn"
        ],
        [
          "executive2 name",
          "String",
          "Returns selected company’s executive2 name"
        ],
        [
          "executive2 title",
          "String",
          "Returns selected company’s executive2 title"
        ],
        [
          "executive2 pay",
          "String",
          "Returns selected company’s executive2 pay"
        ],
        [
          "executive2 exercised",
          "String",
          "Returns selected company’s executive2 exercised"
        ],
        [
          "executive2 yearborn",
          "String",
          "Returns selected company’s executive2 yearborn"
        ],
        [
          "executive3 name",
          "String",
          "Returns selected company’s executive3 name"
        ],
        [
          "executive3 title",
          "String",
          "Returns selected company’s executive3 title"
        ],
        [
          "executive3 pay",
          "String",
          "Returns selected company’s executive3 pay"
        ],
        [
          "executive3 exercised",
          "String",
          "Returns selected company’s executive3 exercised"
        ],
        [
          "executive3 yearborn",
          "String",
          "Returns selected company’s executive3 yearborn"
        ],
        [
          "executive4 name",
          "String",
          "Returns selected company’s executive4 name"
        ],
        [
          "executive4 title",
          "String",
          "Returns selected company’s executive4 title"
        ],
        [
          "executive4 pay",
          "String",
          "Returns selected company’s executive4 pay"
        ],
        [
          "executive4 exercised",
          "String",
          "Returns selected company’s executive4 exercised"
        ],
        [
          "executive4 yearborn",
          "String",
          "Returns selected company’s executive4 yearborn"
        ],
        [
          "executive5 name",
          "String",
          "Returns selected company’s executive5 name"
        ],
        [
          "executive5 title",
          "String",
          "Returns selected company’s executive5 title"
        ],
        [
          "executive5 pay",
          "String",
          "Returns selected company’s executive5 pay"
        ],
        [
          "executive5 exercised",
          "String",
          "Returns selected company’s executive5 exercised"
        ],
        [
          "executive5 yearborn",
          "String",
          "Returns selected company’s executive5 yearborn"
        ],
        [
          "company decription",
          "String",
          "Returns selected company’s description"
        ]
      ]
    }
  },

  "Company Financial Summary": {
    api_category: beta_api_category[1],
    costs: ["10 credit per data point"],
    description: [
      "Company Financial Summary includes a summary for the public U.S stocks."
    ],
    base_url: "https://api.unibit.ai/api/financials/summary/",
    template_urls: [
      "https://api.unibit.ai/api/financials/summary/{{ticker}}?datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/financials/summary/AAPL?AccessKey=Demo"],
    csv_urls: [
      "https://api.unibit.ai/api/financials/summary/AAPL?datatype=csv&AccessKey=Demo"
    ],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["key", "type", "Description"],
      table_data: [
        ["open", "String", "Returns open price for the stock"],
        [
          "previous_close",
          "String",
          "Return previous close price for the stock"
        ],
        [
          "market_cap",
          "String",
          "Returns current market capitalization for the stock"
        ],
        [
          "forward_dividend_yield",
          "String",
          "Returns forward dividend yield for the stock"
        ],
        ["avg_volume", "String", "Returns average volume for the stock"],
        [
          "ex_dividend_date",
          "String",
          "Returns ex-dividend date for the stock"
        ],
        ["beta", "String", "Returns beta for the stock"],
        [
          "pe_ratio",
          "String",
          "Returns Price to Earning ratio for the stock"
        ],
        ["eps", "String", "Returns earning per share for for the stock"],
        ["week_52_range", "String", "Returns 52 week range for the stock"],
        ["earnings_date", "String", "Returns earning date for the stock"],
        ["sentiment", "Number", "Returns sentiment score for the stock"]
      ]
    }
  },

  "Ownership Structure": {
    api_category: beta_api_category[1],
    costs: ["300 credit per data point"],
    description: [
      "Ownership structure dataset contains detailed institutional ownership information for all 8000 actively traded U.S stocks.",
      "Ownership type includes Majority Holder, Top Institutional Holder and Mutual Fund Holder."
    ],
    base_url: "https://api.unibit.ai/api/ownership/",
    template_urls: [
      "https://api.unibit.ai/api/ownership/{{ticker}}?ownership_type={{see possible options}}&datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/ownership/AAPL?ownership_type=majority_holder&AccessKey=Demo",
      "https://api.unibit.ai/api/ownership/AAPL?ownership_type=top_institutional_holder&AccessKey=Demo",
      "https://api.unibit.ai/api/ownership/AAPL?ownership_type=top_mutual_fund_holder&AccessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/ownership/AAPL?ownership_type=majority_holder&datatype=csv&AccessKey=Demo"
    ],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          [
            "ownership_type",
            "Required",
            'Choose from "majority_holder, top_institutional_holder, top_mutual_fund_holder, or all"'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description:
        "*Major holders include the ownership percentage of each major institution",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Returns selected company’s ticker"],
        [
          "Holder",
          "String",
          "Returns owner's name for the company selected "
        ],
        [
          "Shares",
          "Number",
          "Returns owner's shares number for the company selected"
        ],
        [
          "Date Reported",
          "String",
          "Returns reported date for the company selected "
        ],
        [
          "% Out",
          "Number",
          "Returns ownership percentage for the company selected"
        ],
        [
          "Value",
          "Number",
          "Returns ownership value in dollars for the company selected"
        ]
      ]
    },
    possible_options: {
      description: "",
      table_header: ["Ownership Type", "Update Frequency", "Description"],
      table_data: [
        [
          "majority_holder",
          "Daily",
          "Returns majority owner of a selected company"
        ],
        [
          "top_institutional_holder",
          "Daily",
          "Returns top institutional owner of a selected company"
        ],
        [
          "top_mutual_fund_holder",
          "Daily",
          "Returns top mutual fund owner of a selected company"
        ]
      ]
    }
  },

  "Insider Transaction": {
    api_category: beta_api_category[1],
    costs: ["300 credit per data point"],
    description: [
      "The insider transaction database contains all reported purchases and sales of company stock from their insider roster."
    ],
    feature: [
      "Parsed from the SEC form 4",
      "Filing type contains Purchase(P), Sale(Sale), Grant(A), Sale to Issuer(D), Gift(G), Tax(F), Exercise of Options(M), Exercise of Options(X), Converted Derivative(C), Inherited(W)",
      "The insider transaction database is updated daily at 06:00 AM (ET)"
    ],
    base_url: "https://api.unibit.ai/api/insidertrading/",
    template_urls: [
      "https://api.unibit.ai/api/insidertrading/{{ticker}}?size={{A Positive Integer}}datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/insidertrading/AAPL?size=8&AccessKey=Demo"],
    csv_urls: ["https://api.unibit.ai/api/insidertrading/AAPL?datatype=csv&AccessKey=Demo"],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          [
            "size",
            "Optional",
            "Default size is 10. Will return the number of latest insider transactions."
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Returns the selected company ticker"],
        [
          "price",
          "String",
          "Return the average purchase price from the insider"
        ],
        [
          "type",
          "String",
          "Returns the type of transaction from the insider either sale/purchase"
        ],
        [
          "trade_date",
          "String",
          "Returns the exact trade time for the transaction"
        ],
        [
          "filing_date",
          "String",
          "Returns the filing date for the transaction"
        ],
        ["trade_type", "String", "Returns the transaction type"],
        ["value", "String", "Returns the total value for the transaction"],
        [
          "owned",
          "String",
          "Returns the total shares owned after the transaction"
        ],
        [
          "change_own",
          "String",
          "Returns the change in percentage after the transaction"
        ],
        [
          "insider_name",
          "String",
          "Returns the insider name for the transaction involved"
        ],
        [
          "insider_title",
          "String",
          "Returns the insider job title for the transaction involved"
        ],
        ["qty", "String", "Returns the number of shares being transacted"]
      ]
    }
  },

  "SEC Filing Link": {
    api_category: beta_api_category[1],
    costs: ["1 credit per data point"],
    description: [],
    base_url: "https://api.unibit.ai/api/company/sec/",
    template_urls: [
      "https://api.unibit.ai/api/company/sec/{{ticker}}?datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/company/sec/AAPL?AccessKey=Demo"],
    csv_urls: ["https://api.unibit.ai/api/company/sec/AAPL?datatype=csv&AccessKey=Demo"],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Description"],
        table_data: [
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["cik", "Number", "Return company’s CIK (Central Index Key)"],
        ["description", "String", "SEC filing type description"],
        ["filing_type", "String", "Returns company’s SEC filing type"],
        ["datetime", "Number", "Returns company’s filing date"],
        ["txt_url", "String", "Returns company filing’s parsed .txt file"],
        ["html_url", "String", "Returns company filing’s parsed html file"]
      ]
    }
  },

  "Latest Stock News": {
    api_category: beta_api_category[1],
    costs: ["50 credit per data point"],
    description: [
      "Latest Stock News provides you the latest news coverage for all 8000 actively listed U.S equities in the past day. Updated every 30 minutes."
    ],
    base_url: "https://api.unibit.ai/api/news/latest/",
    template_urls: [
      "https://api.unibit.ai/api/news/latest/{{ticker}}?datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/news/latest/AAPL?AccessKey=Demo"],
    csv_urls: ["https://api.unibit.ai/api/news/latest/AAPL?datatype=csv&AccessKey=Demo"],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["title", "String", "Returns the new title"],
        ["datetime", "String", "Returns datetime for the news"]
      ]
    }
  },

  "Stock News by Event Classification": {
    api_category: beta_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "Event Summary, Headline, Datetime, URL: get and search live headlines, articles summary, images",
      'Genre Tags: get business news event through 50 different classes including "product release, lawsuit, media, analyst estimates, corporate leadership and etc…"',
      "Related Sector: Get the related industry sector for the news event",
      "Asset: 8000 U.S companies and ETFs",
      "Source: 30,000 different news publishers",
      "Timeliness: updated every 30 minute"
    ],
    coverage: [
      "Asset: 8000 U.S companies and ETFs",
      "Source: over 200 business-related publisher",
      "Timeliness: daily"
    ],
    base_url: "https://api.unibit.ai/api/news/classification/",
    template_urls: [
      "https://api.unibit.ai/api/news/classification/{{ticker}}?range={{see possible options}}&event_genre={{see possible options}}&event_sector={{see possible options}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/news/classification/AAPL?range=1w&event_genre=Partnership&event_sector=Technology&AccessKey=Demo",
      "https://api.unibit.ai/api/news/classification/AAPL?range=1m&event_genre=Partnership&event_sector=Technology&AccessKey=Demo",
      "https://api.unibit.ai/api/news/classification/AAPL?range=3m&event_genre=Partnership&event_sector=Technology&AccessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/news/classification/AAPL?range=1w&event_genre=Partnership&event_sector=Technology&datatype=csv&AccessKey=Demo"
    ],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Optional", "The symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          [
            "event_genre",
            "Optional",
            "Choose one from “M&A, partnership, credit market, expansion, funding, analyst estimate, data leak, product release, regulatory, blockchain, fraud, lawsuit, charity, education, philanthropy, retail, analyst rating, bankruptcy, international affairs, cyber security, antitrust, corruption, tariff, environment, earnings, labor market, fixed income, food, commodities, media, climate change, startup, autonomous car, achievement, corporate leadership, investment, pharmaceutical, energy market, equities, financing, valuation, intellectual property, currencies, market performance, taxation, economic data, cloud computing, trade, central bank, product, automotive, machine learning, recession, emerging market, technical analysis."
          ],
          [
            "event_sector",
            "Optional",
            "Choose one from “healthcare, energy, basic materials, industrials, technology, financial services, communication services, consumer cyclical, consumer defensive, utilities, real estate"
          ],
          ["range", "Required", "Specify the time range"],
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Returns company ticker"],
        [
          "title",
          "String",
          "Returns news headlines related to the selected company ticker"
        ],
        [
          "author",
          "String",
          "Returns news author, contribute related to the selected company ticker"
        ],
        [
          "description",
          "String",
          "Returns news article summary related to the selected company ticker"
        ],
        [
          "url",
          "String",
          "Returns news article web URL related to the selected company ticker"
        ],
        ["source", "String", "Returns the source of the news article"],
        [
          "published_at",
          "String",
          "Return original publish time for the news article"
        ],
        [
          "tags: event_sector",
          "String",
          "Returns industry sector related to the article"
        ],
        [
          "tags: event_genre",
          "String",
          "Event classification predicted through deep learning"
        ]
      ]
    },
    possible_options: {
      description: "",
      table_header: ["range", "Frequency", "Description"],
      table_data: [
        ["realtime", "Real time", "Provides intraday latest news"],
        ["1w", "One week", "Provides all company news in the past week"],
        [
          "1m",
          "One month",
          "Provides all monthly company news in the past month"
        ],
        ["3m", "Three months", "Provides company news for the past 3 months"]
      ]
    }
  },

  "Stock News by Sentiment": {
    api_category: beta_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "Sentiment Indicator: get sentiment score for every news article",
      "Event Summary, Headline, Datetime, URL: get and search live headlines, articles summary, images"
    ],
    base_url: "https://api.unibit.ai/api/news/sentiment/",
    template_urls: [
      "https://api.unibit.ai/api/news/sentiment/{{ticker}}?range={{see possible options}}&AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/news/sentiment/AAPL?range=1w&AccessKey=Demo"],
    csv_urls: [
      "https://api.unibit.ai/api/news/sentiment/AAPL?range=1w&datatype=csv&AccessKey=Demo"
    ],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Optional", "The symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          ["range", "Optional", "Specify the time range"],
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Returns company ticker"],
        [
          "title",
          "String",
          "Returns news headlines related to the selected company ticker"
        ],
        [
          "author",
          "String",
          "Returns news author, contribute related to the selected company ticker"
        ],
        [
          "description",
          "String",
          "Returns news article summary related to the selected company ticker"
        ],
        [
          "url",
          "String",
          "Returns news article web URL related to the selected company ticker"
        ],
        ["source", "String", "Returns the source of the news article"],
        [
          "published_at",
          "String",
          "Return original publish time for the news article"
        ],
        [
          "sentiment",
          "Number",
          "Returns sentiment score from -1 to 1 based on news content for the selected company ticker"
        ]
      ]
    },
    possible_options: {
      description: "",
      table_header: ["range", "Frequency", "Description"],
      table_data: [
        ["realtime", "Real time", "Provides intraday latest news"],
        ["1w", "One week", "Provides all company news in the past week"],
        [
          "1m",
          "One month",
          "Provides all monthly company news in the past month"
        ],
        ["3m", "Three months", "Provides company news for the past 3 months"]
      ]
    }
  },

  "Stock News by Name Entities": {
    api_category: beta_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "This API returns all the business news with 3 name entities; location, person and organization ",
      "Name Entity: get a list of people, organizations, locations, dates and currencies from each news event"
    ],
    base_url: "https://api.unibit.ai/api/news/entities/",
    template_urls: [
      "https://api.unibit.ai/api/news/entities/{{ticker}}?range={{see possible options}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/news/entities/AAPL?range=1w&AccessKey=Demo",
      "https://api.unibit.ai/api/news/entities/AAPL?range=1m&AccessKey=Demo",
      "https://api.unibit.ai/api/news/entities/AAPL?range=3m&AccessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/news/entities/AAPL?range=1w&datatype=csv&AccessKey=Demo"
    ],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Optional", "The symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          ["range", "Required", "Specify the time range"],
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Returns company ticker"],
        [
          "title",
          "String",
          "Returns news headlines related to the selected company ticker"
        ],
        [
          "author",
          "String",
          "Returns news author, contribute related to the selected company ticker"
        ],
        [
          "description",
          "String",
          "Returns news article summary related to the selected company ticker"
        ],
        [
          "url",
          "String",
          "Returns news article web URL related to the selected company ticker"
        ],
        ["source", "String", "Returns the source of the news article"],
        [
          "published_at",
          "String",
          "Return original publish time for the news article"
        ],
        [
          "event_location, event_organization, event_person",
          "String",
          "Returns people names, locations, and organizations found in the selected company ticker"
        ]
      ]
    },
    possible_options: {
      description: "",
      table_header: ["range", "Frequency", "Description"],
      table_data: [
        ["realtime", "Real time", "Provides intraday latest news"],
        ["1w", "One week", "Provides all company news in the past week"],
        [
          "1m",
          "One month",
          "Provides all monthly company news in the past month"
        ],
        ["3m", "Three months", "Provides company news for the past 3 months"]
      ]
    }
  },

  /**
   * Forex APIs
   */
  // "Realtime Forex Price": {
  //   api_category: beta_api_category[2],
  //   costs: ["10 credit per data point"],
  //   description: [
  //     "The real time currency data endpoint returns data for over 20,000 currency combination, updated every 5 minute."
  //   ],
  //   feature: ["Cover 147 currency pairs"],
  //   base_url: "https://api.unibit.ai/api/forexrealtime/",
  //   template_urls: [
  //     "https://api.unibit.ai/api/forexrealtime/{{base currency}}?currency={{A list of target currencies}}&size={{A positive Integer}}&datatype={{json}}&AccessKey={{your access key}}"
  //   ],
  //   example_urls: [
  //     "https://api.unibit.ai/api/forexrealtime/USD?currency=CNY,EUR,INR&size=3&AccessKey=Demo",
  //     "https://api.unibit.ai/api/forexrealtime/CNY?currency=USD,EUR&AccessKey=Demo"
  //   ],
  //   csv_urls: [
  //     "https://api.unibit.ai/api/forexrealtime/CNY?currency=USD,EUR&datatype=csv&AccessKey=Demo"
  //   ],
  //   input_params: {
  //     path_params: {
  //       description: "",
  //       table_header: ["Parameters", "Requirement", "Details"],
  //       table_data: [
  //         [
  //           "base",
  //           "Required",
  //           "Choose the base currency of a country. Ex. USD"
  //         ]
  //       ]
  //     },
  //     query_params: {
  //       description: "",
  //       table_header: ["Parameters", "Requirement", "Details"],
  //       table_data: [
  //         [
  //           "currency",
  //           "Optional",
  //           "Enter comma separated values of the currencies listed above. Default: if no target currency specified, return all real time Forex quotes of that base currency from today (00:00 GMT)."
  //         ],
  //         [
  //           "amount",
  //           "Optional",
  //           "Choose the amount of base currency. The default is 1."
  //         ],
  //         [
  //           "size",
  //           "Optional",
  //           "Choose the size of the json objects for each currency. The default is 1."
  //         ],
  //         data_type_param,
  //         access_key_param
  //       ]
  //     }
  //   },
  //   response_params: {
  //     meta_data: {
  //       datapoints: 50,
  //       base: "USD",
  //       "credit cost": 500,
  //       "Time Zone": "America/New_York",
  //       "last refreshed": "06/07/2019 at 05:16PM ET"
  //     },
  //     description: "",
  //     table_header: ["name", "type", "Description"],
  //     table_data: [
  //       ["Base Currency", "String", "Returns the base currency name"],
  //       ["Target Currency", "String", "Returns the target currency name"],
  //       ["amount", "Number", "Returns the amount of the target currency"],
  //       [
  //         "datetime",
  //         "String",
  //         "Returns the datetime in “yyyy-MM-dd HH:mm:ss” format (GMT)."
  //       ],
  //       [
  //         "timestamp",
  //         "Number",
  //         "Returns the timestamp (GMT) base on the value of datetime."
  //       ]
  //     ]
  //   }
  // },

  /**
   * Crypto APIs
   */
  "Historical Crypto Price": {
    api_category: beta_api_category[3],
    costs: ["10 credit per data point"],
    description: [
      "Historical Crypto Prices - Historical crypto prices cover a list of most liquid 100+ cryptos. The data points include Open, high, low, open, close and volume. They go back as far as 5 years ago."
    ],
    feature: [
      "Covers 100+ most liquid cryptos traded in major exchanges.",
      "Includes unadjusted and adjusted open, high, low, close, volume.",
      "Historic data is updated at 12:00am ET on all trading days.",
      "Historical data returns 1-10 years of data depending on the Initial Coin Offering (ICO) of each coin.",
      "This API returns intraday time series data (open, high, low, volume) for any specified stock."
    ],


    base_url: "https://api.unibit.ai/api/historicalcryptoprice/",
    template_urls: [
      "https://api.unibit.ai/api/historicalcryptoprice/{{ticker}}?range={{see possible options}}&interval={{A positive Integer}}&datatype={{json}}&AccessKey={{your access key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/api/historicalcryptoprice/BTC-USD?range=1m&interval=1&AccessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/api/historicalcryptoprice/BTC-USD?range=1m&interval=1&datatype=csv&AccessKey=Demo"
    ],
    possible_options: {
      description: "",
      table_header: ["Time Range", "Frequency", "Description"],
      table_data: [
        ["1m", "One month", "Crypto price quote for the past 1 month"],
        ["3m", "Three months", "Crypto price quote for the past 3 months"],
        ["1y", "One years", "Crypto stock price quote for the past 1 year"],
        ["3y", "Three years", "Crypto price quote for the past 3 years"],
        ["5y", "Five years", "Crypto price quote for the past 5 years"],
        ["10y", "Ten years", "Crypto price quote for the past 10 years"]
      ]
    },
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          ["range", "Required", "Choose from range options above (i.e. 1m)"],
          [
            "interval",
            "Required",
            "A positive Integer (n). If passed, chart data will return every nth element as defined by interval"
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "ETH",
        date: "02/02/2020",
        range: "1 month",
        interval: 1
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        [
          "date",
          "String",
          "Returns the date of the trading session. Date format is: yyyy-mm-dd"
        ],
        ["open", "Number", "Returns open price for the Crypto in a day"],
        [
          "high",
          "Number",
          "Returns the highest price for the Crypto in a day"
        ],
        ["low", "Number", "Returns the lowest price for the Crypto in a day"],
        ["close", "Number", "Returns close price for the Crypto in a day"],
        [
          "adj_close",
          "Number",
          "Returns close price for the Crypto in a day"
        ],
        ["volume", "Number", "Returns trading volume for the Crypto in a day"]
      ]
    }
  },

  /**
   * Reference APIs
   */
  "Asset Coverage": {
    api_category: beta_api_category[4],
    costs: ["1 credit per data point"],
    description: ["This API returns all the assets that we support."],
    feature: ["Updated daily.", "Includes Initial Public Offerings (IPOs)."],
    base_url: "https://api.unibit.ai/api/companylist/",
    template_urls: [
      "https://api.unibit.ai/api/companylist?exchange={{see possible options}}"
    ],
    example_urls: ["https://api.unibit.ai/api/companylist?exchange=NASDAQ&AccessKey=Demo"],
    csv_urls: [
      "https://api.unibit.ai/api/companylist?exchange=NASDAQ&datatype=csv&AccessKey=Demo"
    ],
    possible_options: {
      description: "",
      table_header: ["Exchange Names", "Input Type", "Description"],
      table_data: [
        ["ASX", "String", "Australian Securities Exchange"],
        ["BATS", "String", "BATS Global Markets"],
        ["BOM", "String", "Bombay Stock Exchange"],
        ["BSE", "String", "Brussels Stock Exchange"],
        ["BCBA", "String", "Buenos Aires Stock Exchange"],
        ["CNQ", "String", "Canadaian Securities Exchange"],
        ["OMXC", "String", "Copenhagen Securities Exchange"],
        ["GER", "String", "Deutsche Börse XETRA"],
        ["AEX", "String", "Euronext Amsterdam"],
        ["PAR", "String", "Euronext Paris"],
        ["FRA", "String", "Frankfurt Stock Exchange"],
        ["OMXH", "String", "Helsinki Stock Exchange"],
        ["HKEX", "String", "Hong Kong Stock Exchange"],
        ["BIST", "String", "Istanbul Stock Exchange"],
        ["JSX", "String", "Jakarta Stock Exchange"],
        ["JSE", "String", "Johannesburg Stock Exchange"],
        ["KSC", "String", "Korean Stock Exchange"],
        ["KLS", "String", "Kuala Lumpur Stock Exchange"],
        ["LSE", "String", "London Stock Exchange"],
        ["MAD", "String", "Madrid Stock Exchange"],
        ["MEX", "String", "Mexican Stock Exchange"],
        ["MIL", "String", "Milan Stock Exchange"],
        ["MCX", "String", "Moscow Stock Exchange"],
        ["NASDAQ", "String", "NASDAQ Stock Exchange"],
        ["NSE", "String", "National Stock Exchange of India"],
        ["NYSE", "String", "New York Stock Exchange"],
        ["AMEX", "String", "NYSE American Stock Exchange"],
        ["NYSEARCA", "String", "NYSE Arca Exchange"],
        ["OTCMKTS", "String", "OTC Markets Group"],
        ["DOH", "String", "Qatar Stock Exchange"],
        ["SAO", "String", "Sao Paolo Stock Exchange"],
        ["TADAWUL", "String", "Saudi Stock Exchange"],
        ["SES", "String", "Singapore Exchange"],
        ["SZCE", "String", "Shenzhen Stock Exchange"],
        ["SIX", "String", "SIX Swiss Stock Exchange"],
        ["OMX", "String", "Stockholm Stock Exchange"],
        ["TWSE", "String", "Taiwan Stock Exchange"],
        ["OMXT", "String", "Tallinn Stock Exchange"],
        ["TASE", "String", "Tel Aviv Stock Exchange"],
        ["SET", "String", "Thailand Stock Exchange"],
        ["TSX", "String", "Toronto Stock Exchange"],
        ["TSXV", "String", "TSX Venture Stock Exchange"],
        ["VSE", "String", "Vienna Stock Exchange"],
        ["WSE", "String", "Warsaw Stock Exchange"]
      ]
    },
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [
          [
            "exchange",
            "Required",
            "Choose symbol of a stock exchange provided in possible options table"
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        exchange: "ETH",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["Name", "Type", "Description"],
      table_data: [
        ["ticker", "String", "Return company’s ticker"],
        ["name", "String", "Return company’s name"],
        [
          "exchange",
          "String",
          "Returns the exchange that the security is traded on"
        ],
        [
          "currency",
          "String",
          "Returns the currency that the security is traded with"
        ]
      ]
    }
  },

  "CIK Number": {
    api_category: beta_api_category[4],
    costs: ["10 credit per data point"],
    description: [
      "The Central Index Key (CIK) is used on the SEC's computer systems to identify corporations and individual people who have filed disclosure with the SEC."
    ],
    base_url: "https://api.unibit.ai/api/company/cik/",
    template_urls: [
      "https://api.unibit.ai/api/company/cik/{{ticker}}?AccessKey={{your access key}}"
    ],
    example_urls: ["https://api.unibit.ai/api/company/cik/AAPL?AccessKey=Demo"],
    input_params: {
      path_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [["ticker", "Required", "Choose the symbol of a company"]]
      },
      query_params: {
        description: "",
        table_header: ["Parameters", "Requirement", "Details"],
        table_data: [access_key_param]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: ["name", "type", "Description"],
      table_data: [
        ["ticker", "String", "Return company’s ticker"],
        ["cik", "Number", "Return company’s CIK (Central Index Key)"]
      ]
    }
  }
};
export default Beta_API;

const ticker_input_params = { input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT, name: "ticker", value: "Please enter your ticker here", isRequired: true, isPathParam: true };
const forex_base_input_params = { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "base", value: FOREX_LIST, isRequired: true, isPathParam: true };
const size_input_params = { input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT, name: "size", value: "Must be a positive integer", isRequired: false, isPathParam: false };
const datatype_input_params = { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "datatype", value: ["json", "csv"], isRequired: false, isPathParam: false };
const accesskey_input_params = { input: API_CONTROL_PANEL_INPUT_TYPE.ACCESSKEY_TEXT_INPUT, name: "AccessKey", value: "Please enter your access key here", isRequired: true, isPathParam: false };

export const beta_api_input_params = {
  // "Realtime Stock Price": {
  //   ticker_input_params,
  //   size_input_params,
  //   datatype_input_params,
  //   accesskey_input_params
  // },
  "Historical Stock Price": {
    ticker_input_params,
    range_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "range", value: ["1m", "3m", "1y", "3y", "5y", "10y", "20y"], isRequired: true, isPathParam: false },
    interval_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT, name: "interval", value: "Must be a positive integer", isRequired: true, isPathParam: false },
    datatype_input_params,
    accesskey_input_params
  },
  "Stock Technical Indicators": {
    ticker_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT, name: "ticker", value: "Please enter your ticker here", isRequired: true, isPathParam: false },
    function_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "function", value: TECHNICAL_INDICATORS, isRequired: true, isPathParam: false },
    interval_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "interval", value: ["daily", "weekly", "monthly"], isRequired: true, isPathParam: false },
    range_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "range", value: ["1m", "3m", "1y", "3y", "5y", "10y", "20y"], isRequired: true, isPathParam: false },
    datapoint_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT, name: "data_point", value: "Must be a positive integer", isRequired: true, isPathParam: false },
    series_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "series_type", value: ["open", "close", "high", "low"], isRequired: true, isPathParam: false },
    accesskey_input_params
  },
  "Company Financials": {
    ticker_input_params,
    type_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "type", value: ["income_statement", "balance_sheet", "cash_flow"], isRequired: true, isPathParam: false },
    interval_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "interval", value: ["annual", "quarterly"], isRequired: true, isPathParam: false },
    datatype_input_params,
    accesskey_input_params
  },
  "Company Profile": {
    ticker_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Company Financial Summary": {
    ticker_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Ownership Structure": {
    ticker_input_params,
    type_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "ownership_type", value: ["majority_holder", "top_institutional_holder", "top_mutual_fund_holder"], isRequired: true, isPathParam: false },
    access_key_param
  },
  "Insider Transaction": {
    ticker_input_params,
    size_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "SEC Filing Link": {
    ticker_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Latest Stock News": {
    ticker_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Stock News by Event Classification": {
    ticker_input_params,
    event_genre_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "event_genre", value: EVENT_GENRE, isRequired: false, isPathParam: false },
    event_sector_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "event_sector", value: EVENT_SECTOR, isRequired: false, isPathParam: false },
    range_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "range", value: ["realtime", "1w", "1m", "3m"], isRequired: true, isPathParam: false },
    datatype_input_params,
    accesskey_input_params
  },
  "Stock News by Sentiment": {
    ticker_input_params,
    range_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "range", value: ["realtime", "1w", "1m", "3m"], isRequired: false, isPathParam: false },
    accesskey_input_params
  },
  "Stock News by Name Entities": {
    ticker_input_params,
    range_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "range", value: ["realtime", "1w", "1m", "3m"], isRequired: true, isPathParam: false },
    accesskey_input_params
  },
  // "Realtime Forex Price": {
  //   forex_base_input_params,
  //   currency_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT, name: "currency", value: "Enter comma separated values of currencies.", isRequired: false, isPathParam: false },
  //   amount_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT, name: "amount", value: "Enter the amount of base currency", isRequired: false, isPathParam: false },
  //   size_input_params,
  //   datatype_input_params,
  //   accesskey_input_params
  // },
  "Historical Crypto Price": {
    ticker_input_params,
    range_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "range", value: ["1m", "3m", "1y", "5y", "10y"], isRequired: true, isPathParam: false },
    interval_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT, name: "interval", value: "Must be a positive integer", isRequired: true, isPathParam: false },
    datatype_input_params,
    accesskey_input_params
  },
  "Asset Coverage": {
    exchange_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "exchange", value: EXCHANGE_LIST, isRequired: true, isPathParam: false },
    datatype_input_params,
    accesskey_input_params
  },
  "CIK Number": {
    ticker_input_params,
    accesskey_input_params
  }
};




// WEBPACK FOOTER //
// ./src/assets/apiDocs/stock_api_beta.js